'use client';

import { useEffect } from 'react';
import { saveStoredHeardAbout } from '@/app/lib/heard-about';
import { useUser } from '@/app/providers/UserProvider';

/** Carries a "how did you hear about us" answer given while signed out onto the profile at sign-in. */
export function HeardAboutSync() {
  const userId = useUser()?.auth?.id;
  useEffect(() => {
    if (userId) saveStoredHeardAbout(userId);
  }, [userId]);
  return null;
}
